import {computed} from "@vue/reactivity";
import {useMounted, useWindowSize} from "@vueuse/core";

export function useMyFunctions(){
    const desktopSize = 1200;
    const mobileSize = 768;
    const mounted = useMounted()
    const { width } = useWindowSize()

    const isDesktop = computed(()=>{
        if (!mounted.value) {
            return true
        }
        return (width.value > desktopSize)
    })
    const isMobile = computed(()=>{
        if (!mounted.value) {
            return false
        }
        return (width.value < mobileSize)
    })

    const removeDuplicateProducts = (products:Product[])=>{
        const uniqueProducts = products.filter((product, index, self) =>
            index === self.findIndex((p) => (
                p.id === product.id
            ))
        );
        return uniqueProducts;
    }
    return {isDesktop,isMobile,removeDuplicateProducts}
}
